__turbopack_context__.v({
  "icon": "rKWDxa_icon",
  "partMenuIcon": "rKWDxa_partMenuIcon",
  "partsMenuContainer": "rKWDxa_partsMenuContainer",
});
